import PropTypes from 'prop-types';
import React from 'react';
import Button from 'react-bootstrap/lib/Button';
import { Link } from 'react-router-dom';

import styles from './ButtonOutlined.module.scss';

const ButtonOutlined = ({
  to = null,
  href = null,
  target = null,
  rel = null,
  bsSize = null,
  bsStyle = null,
  onClick = () => {},
  children,
  style,
}) => {
  const button = (
    <Button
      bsSize={bsSize}
      bsStyle={bsStyle}
      className={styles.hollowButton}
      onClick={onClick}
      style={style}
      href={href}
      target={target}
      rel={rel}
    >
      {children}
    </Button>
  );

  if (href) {
    return button; // Return button directly for external links
  }

  return to ? <Link to={to}>{button}</Link> : button;
};

ButtonOutlined.propTypes = {
  bsSize: PropTypes.string,
  bsStyle: PropTypes.string,
  to: PropTypes.string,
  href: PropTypes.string,
  target: PropTypes.string,
  rel: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.node,
  ]),
  onClick: PropTypes.func,
  style: PropTypes.object,
};

export default ButtonOutlined;
